import {IEntityState} from '@core/state/entities/entity';
import {IEntityKeyTypeMap} from '@core/state/entities/entities';

export type EntityMaps<TKeys extends EntityKeys> = Pick<IEntityNameMap, TKeys>;

type IEntityStateMap = {
  [key in EntityKeys]: IEntityState<IEntityKeyTypeMap[key]>;
};

export type IEntityNameMap = {
  [key in EntityKeys]: IEntityStateMap[key]['byId'];
};



export type MembershipsKey = typeof entityKey.memberships;
export type SearchesKey = typeof entityKey.searches;
export type StagesKey = typeof entityKey.stages;
export type AnnotationQuestionsKey = typeof entityKey.annotationQuestions;
export type ProjectsKey = typeof entityKey.projects;
export type ProjectDetailsKey = typeof entityKey.projectDetails;
export type ProjectSecureDetailsKey = typeof entityKey.projectSecureDetails;
export type ProjectScreeningStatsKey = typeof entityKey.projectScreeningStats;
export type StageAnnotationStatsKey = typeof entityKey.stageAnnotationStats;
export type MembershipAnnotationStatsKey = typeof entityKey.membershipAnnotationStats;
export type MembershipScreeningStatsKey = typeof entityKey.membershipScreeningStats;
export type StudiesKey = typeof entityKey.studies;
export type AnnotationsKey = typeof entityKey.annotations;
export type ScreeningsKey = typeof entityKey.screenings;
export type SessionsKey = typeof entityKey.sessions;
export type StudyDetailsKey = typeof entityKey.studyDetails;
export type InvestigatorsKey = typeof entityKey.investigators;
export type InvestigatorSecureDetailsKey = typeof entityKey.investigatorSecureDetails;
export type OutcomeDataKey = typeof entityKey.outcomeData;
export type ProjectGroupsKey = typeof entityKey.projectGroups;
export type ProjectUsageKey = typeof entityKey.projectUsages;
export type StageUsageKey = typeof entityKey.stageUsages;
export type SearchImportJobsKey = typeof entityKey.searchImportJobs;
export type JoinRequestsKey = typeof entityKey.joinRequests;
export type InvitationsKey = typeof entityKey.invitations;
export type InvitationSecureDetailsKey = typeof entityKey.invitationSecureDetails;
export type AdminInvestigatorsKey = typeof entityKey.adminInvestigators;
export type EmailTemplatesKey = typeof entityKey.emailTemplates;
export type ReviewerScreeningStatsKey = typeof entityKey.reviewerScreeningStats;
export type ReviewerAnnotationStatsKey = typeof entityKey.reviewerAnnotationStats;
export type ScreeningEntityKey = typeof entityKey.screenings;
export type SessionEntityKeys = typeof entityKey.sessions;
export type BulkStudyUpdateJobsKey = typeof entityKey.bulkStudyUpdateJobs;
export type DataExportJobsKey = typeof entityKey.dataExportJobs;
export type BulkPdfUploadJobsKey = typeof entityKey.bulkPdfUploadJobs;

export const entityKey = {
  memberships: 'memberships',
  searches: 'searches',
  stages: 'stages',
  annotations: 'annotations',
  annotationQuestions: 'annotationQuestions',
  projects: 'projects',
  projectScreeningStats: 'projectScreeningStats',
  stageAnnotationStats: 'stageAnnotationStats',
  membershipScreeningStats: 'membershipScreeningStats',
  membershipAnnotationStats: 'membershipAnnotationStats',
  projectDetails: 'projectDetails',
  projectSecureDetails: 'projectSecureDetails',
  projectPermissionSets: 'projectPermissionSets',
  stagePermissionSets: 'stagePermissionSets',
  studies: 'studies',
  sessions: 'sessions',
  studyDetails: 'studyDetails',
  outcomeData: 'outcomeData',
  investigators: 'investigators',
  investigatorSecureDetails: 'investigatorSecureDetails',
  projectGroups: 'projectGroups',
  projectUsages: 'projectUsages',
  stageUsages: 'stageUsages',
  searchImportJobs: 'searchImportJobs',
  joinRequests: 'joinRequests',
  invitations: 'invitations',
  invitationSecureDetails: 'invitationSecureDetails',
  screenings: 'screenings',
  adminInvestigators: 'adminInvestigators',
  emailTemplates: 'emailTemplates',
  reviewerScreeningStats: 'reviewerScreeningStats',
  reviewerAnnotationStats: 'reviewerAnnotationStats',
  bulkStudyUpdateJobs: 'bulkStudyUpdateJobs',
  riskOfBiasJobs: 'riskOfBiasJobs',
  bulkPdfUploadJobs: 'bulkPdfUploadJobs',
  dataExportJobs: 'dataExportJobs',
dataExportRequests: 'dataExportRequests',

} as const;
export type EntityKey = typeof entityKey[keyof typeof entityKey];

export type EntityKeys = keyof IEntityKeyTypeMap;
